import React from 'react';
import EventLogo from "./ImagesUpload/EventLogo";
import FavIcon from './ImagesUpload/FavIcon';

const EventPageAccordion = ({ formik, isRestricted = false }) => {
    return (
        <>
            <div className="row">
                <div className="col-md-6 d-flex flex-column justify-content-center">
                    <p className="label mb-0">Event Page Logo</p>
                    <p className="description-text mb-0 mt-2">Event page logo will be displayed on top left corner of your event page.</p>
                    <p className="description-text mt-2">(Recommended dimension is 2:1)</p>
                </div>
                <div className="col-md-6">
                    <EventLogo formik={formik} isRestricted={isRestricted}/>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 d-flex flex-column justify-content-center">
                    <p className="label mb-0">Event Page Fav Icon</p>
                    <p className="description-text mb-0 mt-2">Fav icon will be displayed on event page tabs at the top of a web browser.</p>
                    <p className="description-text mt-2">(Recommended dimension is 1:1)</p>
                </div>
                <div className="col-md-6 justify-content-end d-flex">
                    <div className='px-3 py-4'>
                        <FavIcon
                            iconUrl={formik.values.fav_icon}
                            onIconChange={(iconUrl) => formik.setFieldValue("fav_icon", iconUrl)}
                            error={formik.errors.fav_icon && formik.touched.fav_icon ? formik.errors.fav_icon : false}
                            isRestricted={isRestricted}
                        />
                    </div>
                </div>
            </div>
            {/*<div className="row">
                <div className="col-md-6 d-flex flex-column justify-content-center">
                    <p className="label mb-0">Remove Event Page Footer</p>
                    <p className="description-text mb-0 mt-2">You can choose to remove the footer from your event page.</p>
                </div>
                <div className="col-md-6">

                </div>
            </div>*/}
        </>
    )
}

export default EventPageAccordion;